import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { LogModel } from '../models/log.model';

@Injectable({
  providedIn: 'root',
})
export class LogService extends BaseService {
  public saveLog(data: LogModel): Observable<boolean> {
    return this.post('logs', data);
  }

  public getAllLogs(filter: any): Observable<LogModel[]> {
    return this.post('logs/getAll', filter);
  }
}
